import AboutLPCtaButton from 'components/v2/modules/about-lp/cta-button';

interface ActionSectionPropsType {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonUrl?: string;
  className?: string;
}

const ActionSection = ({
  title = 'PostPrimeで投資を始めよう',
  description = 'まもなく50万人突破の投資コミュニティに今すぐ参加しましょう。',
  buttonText = '無料で始める',
  buttonUrl = '/',
  className = '',
}: ActionSectionPropsType) => {
  return (
    <div
      className={`my-12 rounded-2xl bg-green-50 p-10 text-center ${className}`}
    >
      <h3 className="mb-4 text-2xl font-bold text-gray-800">{title}</h3>
      <p className="mb-6 text-lg text-gray-500">{description}</p>
      <AboutLPCtaButton
        text={buttonText}
        href={buttonUrl}
        type="greenWithArrow"
        position="body"
      />
    </div>
  );
};

export default ActionSection;
